"use client";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Link } from "@/components/common/Link";
import {
  ShopBreadcrumbsProvider,
  useShopBreadcrumbs,
} from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import {
  EcommerceTermsProvider,
  useEcommerceTerms,
} from "@/integrations/wordpress/WordPressEcommerceTermsProvider";

function ShopBreadcrumbsConsumer() {
  const { links, loading, error } = useShopBreadcrumbs();

  if (loading || error || links.length === 0) return null;

  const lastIndex = links.length - 1;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {links.map((link, index) => (
          <BreadcrumbItem key={link.href} data-index={index}>
            {index === lastIndex ? (
              <BreadcrumbPage>{link.title}</BreadcrumbPage>
            ) : (
              <>
                <BreadcrumbLink asChild>
                  <Link to={link.href} className="text-foreground">
                    {link.title}
                  </Link>
                </BreadcrumbLink>
                <BreadcrumbSeparator />
              </>
            )}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}

function ArchiveTitleConsumer() {
  const { terms, loading, error } = useEcommerceTerms();

  if (loading) {
    return (
      <div className="h-12 w-64 animate-pulse rounded-md bg-muted/30" />
    );
  }

  if (error || terms.length === 0) {
    return <h1 className="font-default text-5xl font-bold text-foreground">Archive</h1>;
  }

  const archiveTitle = terms[0]?.name || "Archive";

  return (
    <h1 className="font-default text-5xl font-bold text-foreground">
      {archiveTitle}
    </h1>
  );
}

export default function ArchiveTitleSection() {
  const current_wp_term_query_params = (window as any).wvcClient?.getCurrentWPTermQueryParams?.() || {};
  const wp_term_query = new WP_Term_Query(current_wp_term_query_params);

  return (
    <section id="archive-title-section" className="bg-background py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <ShopBreadcrumbsProvider>
          <div className="mb-8">
            <ShopBreadcrumbsConsumer />
          </div>
        </ShopBreadcrumbsProvider>

        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <ArchiveTitleConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>
  );
}